import { Messages } from '../../../../codegen/Localize';
import { ISiteSettingsForServerAdmin } from '../../../../settings/types/ISite';
import { activateSite } from '../../../actions/spaces/SiteMenuActions';
import { EntityActionNames, IEntityAction } from './IEntityAction';
import { canChangeSiteAvailability } from './IEntityActionHelpers';
import { SiteAvailabilityState } from '../../../../sites/SitePropertyTypes';

export const ActivateSiteAction: IEntityAction<ISiteSettingsForServerAdmin, {}> = {
  name: EntityActionNames.ActivateSite,
  translateName: Messages.activate_action,
  isVisible: (targetItems: ISiteSettingsForServerAdmin[]) => {
    return targetItems.length > 0;
  },
  isClickable: (_availableActions: {}, targetItems: ISiteSettingsForServerAdmin[]) => {
    return canChangeSiteAvailability(targetItems, SiteAvailabilityState.ACTIVE);
  },
  createReduxAction: (targetItems: ISiteSettingsForServerAdmin[]) => activateSite(targetItems)
};
